import React from 'react';

interface clientItemScoringProps {
  itemScore: number;
  updateScore: (score: number) => void;
}

export const ClientItemScoring: React.FC<clientItemScoringProps> = ({
  itemScore,
  updateScore
}) => {
  // Score colors from Red (1) to Green (5)
  const getScoreColor = (score: number, isSelected: boolean) => {
    if (!isSelected) return { bg: "#F3F4F6", text: "#6B7280", border: "#E5E7EB" };

    switch (score) {
      case 1: return { bg: "#dc2626", text: "#fff", border: "#dc2626" }; // Red
      case 2: return { bg: "#ea580c", text: "#fff", border: "#ea580c" }; // Orange
      case 3: return { bg: "#eab308", text: "#fff", border: "#eab308" }; // Yellow
      case 4: return { bg: "#84cc16", text: "#fff", border: "#84cc16" }; // Light Green
      case 5: return { bg: "#16a34a", text: "#fff", border: "#16a34a" }; // Green
      case 0: return { bg: "#6B7280", text: "#fff", border: "#6B7280" }; // N/A (Gray)
      default: return { bg: "#F3F4F6", text: "#6B7280", border: "#E5E7EB" };
    }
  };

  return (
    <div style={{ display: "flex", gap: "6px", alignItems: "center", flexWrap: "wrap" }}>
      {[1, 2, 3, 4, 5].map((score) => {
        const isSelected = score === itemScore;
        const colors = getScoreColor(score, isSelected);

        return (
          <button
            key={score}
            onClick={() => updateScore(score)}
            style={{
              width: "36px",
              height: "36px",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: isSelected ? 800 : 600,
              fontSize: "0.95rem",
              background: colors.bg,
              color: colors.text,
              border: `1px solid ${colors.border}`,
              cursor: "pointer",
              transition: "all 0.15s ease",
              boxShadow: isSelected ? `0 2px 8px ${colors.bg}66` : "none"
            }}
            onMouseEnter={(e) => {
              if (!isSelected) {
                e.currentTarget.style.background = "#E5E7EB";
                e.currentTarget.style.color = "#374151";
              }
            }}
            onMouseLeave={(e) => {
              if (!isSelected) {
                e.currentTarget.style.background = colors.bg;
                e.currentTarget.style.color = colors.text;
              }
            }}
          >
            {score}
          </button>
        );
      })}

      {/* N/A Button */}
      {(() => {
        const isSelected = 0 === itemScore;
        const colors = getScoreColor(0, isSelected);

        return (
          <button
            key={0}
            onClick={() => updateScore(0)}
            style={{
              height: "36px",
              padding: "0 12px",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: isSelected ? 800 : 600,
              fontSize: "0.85rem",
              background: colors.bg,
              color: colors.text,
              border: `1px solid ${colors.border}`,
              cursor: "pointer",
              transition: "all 0.15s ease",
              marginLeft: "4px"
            }}
          >
            N/A
          </button>
        );
      })()}
    </div>
  );
};
